import { registeredTabsHandlers } from '@/global/components/view-layouts/tabs-layout/common/registered-tabs-handlers'
import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { isObject, cloneDeep } from '@/global/utils/utils'
import { api } from '@/global/services/api'
import { dateService, FORMATS } from '@/global/services/date'

export default {
  methods: {
    onShowRangeDetails (event) {
      const { setFormData } = registeredTabsHandlers?.rangeLimits || {}
      const { data } = event || {}
      const clonedData = cloneDeep(data)
      const { showDetails, setDetailsTitle } = this.blockConfig || {}
      const appendToDetailsTitle = clonedData.limit_type || this.$t('fleet/vehicle.details')
      const detailsTitle = this.$t('fleet/vehicle.range_limit') + ' - ' + appendToDetailsTitle

      if (typeof setFormData === 'function' && data && isObject(data)) {
        // convert dates for correct display
        clonedData.input_date = clonedData?.input_date ? dateService.formatCustom(data.input_date, FORMATS.isoDate, FORMATS.date) : null
        clonedData.valid_until_date = clonedData?.valid_until_date ? dateService.formatCustom(data.valid_until_date, FORMATS.isoDate, FORMATS.date) : null

        this.rangeDetailsTitle = detailsTitle
        setDetailsTitle?.(detailsTitle)
        setFormData(clonedData)
      }

      showDetails?.()
      this.showRangeTable = false
      this.showRangeDetails = true
    },

    onRangeLimitActivation (event) {
      const { status, id, limit_type: limitType } = event?.data || {}
      if (!id) {
        return
      }
      const title = status ? this.$t('fleet/vehicle.range_limit_deactivation_title') : this.$t('fleet/vehicle.range_limit_activation_title')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (limitType || '/'))
      this.$set(this.informationDialogConfig, 'message', status ? this.$t('fleet/vehicle.range_limit_deactivation_message') : this.$t('fleet/vehicle.range_limit_activation_message'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.rangeLimitActivation(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async rangeLimitActivation (event) {
      try {
        const { id, status } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.rangeLimits || {}
        const formData = new FormData()
        formData.append('_method', 'PATCH')
        formData.append('status', status ? 'false' : 'true')

        await api('fleet').post(`vehicle-range_limit-status/${id}`, formData)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    onRangeLimitDelete (event) {
      const { id, limit_type: limitType } = event?.data || {}
      if (!id) {
        return
      }

      const title = this.$t('fleet/vehicle.range_limit_delete_title')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (limitType || '/'))
      this.$set(this.informationDialogConfig, 'message', this.$t('fleet/vehicle.range_limit_delete_message'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.rangeLimitDelete(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async rangeLimitDelete (event) {
      try {
        const { id } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.rangeLimits || {}

        await api('fleet').delete(`vehicle-range_limit/${id}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
